export const priceLogicValues = {
    costPriceMarkup: 'costPriceMarkup',
    grossMargin: 'grossMargin',
};

export default priceLogicValues;
